import React, { useState } from 'react'
import { Button, ConfigProvider, Modal, Spin, Upload, message } from 'antd';
import style from "css/address.module.css";
import axios from 'axios';
import { ReactComponent as Close } from "asset/common/close_popup.svg";
import Dragger from 'antd/es/upload/Dragger';
import { InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function ExcelPopup({ isOpen, isRefresh, closeEvent }) {

    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [excelInfo, setExcelInfo] = useState({});
    const [fileList, setFileList] = useState([]);

    const uploadExcel = () => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("file", excelInfo);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };
        axios.post("/address/upload", formData, config)
            .then((res) => {
                if (res.status === 200) {
                    message.success(t("MESSAGE.CONTACT_UPLOAD_COMPLETE", { FILE_NAME: excelInfo.name }));
                    setExcelInfo({});
                    isRefresh();
                    setFileList([]);
                    closeEvent();
                }
            })
            .catch(() => {
                message.error(t("MESSAGE.CONTACT_UPLOAD_FAILED", { FILE_NAME: excelInfo.name }));
            })
            .finally(() => {
                setIsLoading(false);
            })
    };

    const downloadExcelTemplate = () => {
        const config = {
            responseType: "blob",
        };
        axios.get("/address/excel", config).then((res) => {
            const url = window.URL.createObjectURL(
                new Blob([res.data], { type: res.headers["content-type"] })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", t("FILE_NAME.EXCEL.CONTACT_FORM"));
            document.body.appendChild(link);
            link.click();
        });
    }

    const selectEcxcel = (info) => {
        const { status } = info.file;
        if (status === 'uploading') {
            setFileList(info.fileList);
        }
    }

    return (
        <Modal
            open={isOpen}
            footer={[]}
            closable={false}
            centered
        >
            <div className={style.info_popup_container}>
                <div className={style.info_popup_header}>
                    <p className={style.info_popup_title}>
                        {t("LABEL.TITLE.CONTACT_UPLOAD")}
                    </p>
                    <Close
                        className={style.info_popup_close}
                        onClick={() => closeEvent()}
                    />
                </div>

                <div className={style.excel_popup}>
                    {
                        isOpen &&
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimary: "#1cb691",
                                    colorPrimaryHover: "#1cb691",
                                    colorPrimaryActive: "#1cb691",
                                },
                                components: {
                                    Button: {
                                        colorPrimaryHover: "#1cb691",
                                        colorPrimaryActive: "#1cb691",
                                    }
                                }
                            }}
                        >
                            <Dragger
                                className={style.upload_box}
                                name={"file"}
                                multiple={false}
                                customRequest={uploadExcel}
                                maxCount={1}
                                beforeUpload={
                                    (file) => {
                                        const isExcel =
                                            file.type === 'application/haansoftxlsx'
                                            || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                                        // const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                                        if (!isExcel) {
                                            message.error(t("MESSAGE.WRONG_FILE_FORMAT", { FILE_NAME: file.name }));
                                        } else {
                                            setExcelInfo(file);
                                        }
                                        return isExcel || Upload.LIST_IGNORE;
                                    }
                                }
                                onChange={selectEcxcel}
                                fileList={fileList}
                                disabled={isLoading}
                            >
                                {
                                    isLoading
                                        ?
                                        <Spin />
                                        :
                                        <>
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-hint">
                                                {t("MESSAGE.UPLOAD_CONTACT_FILE")}
                                            </p>
                                        </>
                                }
                            </Dragger>


                            <Button
                                onClick={() => downloadExcelTemplate()}
                                type='default'
                            >
                                {t("BTN.DOWNLOAD_FORM")}
                            </Button>
                        </ConfigProvider>
                    }
                </div>
            </div>
        </Modal >
    )
}

export default ExcelPopup
